/** Temporary name fallback until Identity supplies canonical agent branding (COMMIT-30119). */
export const getVendorBrand = (agentName: string): 'claude' | 'chatgpt' | undefined => {
	const trimmedAgentName = agentName.trim();
	const knownNames = [
		{ name: 'Claude Code', brand: 'claude' },
		{ name: 'Claude', brand: 'claude' },
		{ name: 'ChatGPT', brand: 'chatgpt' },
		{ name: 'Codex', brand: 'chatgpt' },
	] as const;

	return knownNames.find(
		({ name }) => trimmedAgentName === name || trimmedAgentName.startsWith(`${name} (`),
	)?.brand;
};
